"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Batch = /** @class */ (function () {
    /**
     * @param opts allows us to change the behavior of the batching.
     * NOTE: all options contain defaults.
     */
    function Batch(opts) {
        var _this = this;
        /**
         * The list of events that are to be sent.
         */
        this.queue = [];
        var _a = opts.ready, ready = _a === void 0 ? true : _a, _b = opts.interval, interval = _b === void 0 ? 500 : _b, handler = opts.handler, _c = opts.withUnload, withUnload = _c === void 0 ? true : _c;
        this._isReady = ready;
        this._intervalTime = interval;
        this.handler = handler;
        // This is we watch for the window unload event.
        if (withUnload)
            window.addEventListener("unload", function () { return _this.flush(true); }, false);
    }
    Object.defineProperty(Batch.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        set: function (ready) {
            this._isReady = ready;
            // If we are ready and have events in the queue then get them ready to flush
            if (ready) {
                if (this.queue.length > 0) {
                    this.startTimer();
                }
            }
            else {
                // Stop the timer if it's running, we aren't ready!
                this.cancelTimer();
            }
        },
        enumerable: false,
        configurable: true
    });
    Batch.prototype.startTimer = function () {
        var _this = this;
        // Already have a timer running.
        if (this._timer)
            return;
        // Don't want to flush stuff if we're not ready!
        if (!this._isReady)
            return;
        this._timer = window.setInterval(function () { return _this.flush(false); }, this._intervalTime);
    };
    Batch.prototype.cancelTimer = function () {
        if (this._timer)
            window.clearInterval(this._timer);
        this._timer = undefined;
    };
    /**
     * Adds an event the the queue
     * @param event The event to add to the queue.
     */
    Batch.prototype.addEvent = function (event) {
        this.queue.push(event);
        this.startTimer();
    };
    /**
     * Sends all of the current queue to the 'handler' func.
     */
    Batch.prototype.flush = function (isSync) {
        if (this.queue.length === 0)
            return;
        try {
            this.handler(this.queue, isSync);
            this.queue = [];
            this.cancelTimer();
        }
        catch (error) { }
    };
    return Batch;
}());
exports.default = Batch;
